import { useAppStore } from '@core/store'
import FloatingPropertiesWindow from './FloatingPropertiesWindow'
import FloatingAppearancePanel from './FloatingAppearancePanel'
import FloatingModelInfoWindow from './FloatingModelInfoWindow'
import FloatingColorByPanel from './FloatingColorByPanel'
import FloatingFilterPanel from './FloatingFilterPanel'
import FloatingLensPanel from './FloatingLensPanel'
import FloatingReportPanel from './FloatingReportPanel'
import FloatingIfcxPanel from './FloatingIfcxPanel'
import FloatingPlanosCortePanel from './FloatingPlanosCortePanel'
import FloatingDadosPanel from './FloatingDadosPanel'
import FloatingEstruturaPanel from './FloatingEstruturaPanel'
import FloatingGloboPanel from './FloatingGloboPanel'
import FloatingJuntarIfc from './FloatingJuntarIfc'
import FloatingEntregaAssinada from './FloatingEntregaAssinada'
import ToastHost from '@core/layout/ToastHost'
import DeepLinkLoader from '@viewer/DeepLinkLoader'
import FireBimHandoffReceiver from '@viewer/FireBimHandoffReceiver'

function PopupsHost() {
  const popups = useAppStore((s) => s.popups)
  return (
    <>
      {popups.map((p) => (
        <FloatingPropertiesWindow key={p.id} popup={p} />
      ))}
      <FloatingAppearancePanel />
      <FloatingModelInfoWindow />
      <FloatingColorByPanel />
      <FloatingFilterPanel />
      <FloatingLensPanel />
      <FloatingReportPanel />
      <FloatingIfcxPanel />
      <FloatingPlanosCortePanel />
      <FloatingDadosPanel />
      <FloatingEstruturaPanel />
      <FloatingGloboPanel />
      <FloatingJuntarIfc />
      <FloatingEntregaAssinada />
      <ToastHost />
      <DeepLinkLoader />
      <FireBimHandoffReceiver />
    </>
  )
}

export default PopupsHost
